import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { V2_NAV_ITEMS } from "@/components/layout/v2NavConfig";
import {
  appBottomNavActiveIndicatorClass,
  appBottomNavClass,
  appBottomNavLinkClass,
} from "@/components/layout/appNavStyles";

const V2BottomNav = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const isActive = (href: string) => location.pathname.startsWith(href);

  return (
    <div
      className={appBottomNavClass}
      role="navigation"
      aria-label={t("v2.nav.mainNavigation")}
    >
      <div className="grid h-16 grid-cols-4">
        {V2_NAV_ITEMS.map((item, index) => {
          const active = isActive(item.href);
          const name = t(item.nameKey);

          return (
            <Link
              key={item.href}
              to={item.href}
              aria-label={name}
              aria-current={active ? "page" : undefined}
              className={appBottomNavLinkClass(active)}
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <item.icon
                className={cn(
                  "h-5 w-5 mb-0.5",
                  active ? "scale-110" : "group-hover:scale-105"
                )}
              />
              <span
                className={cn(
                  "text-[9px] sm:text-[10px] font-medium leading-tight text-center",
                  active ? "font-semibold" : ""
                )}
              >
                {name}
              </span>
              {active && <div className={appBottomNavActiveIndicatorClass} />}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default V2BottomNav;
